import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { environment } from '@env/environment';
import { ToastrService } from '@app/shared/services/toast.service';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs';

import { Logger } from '../logger.service';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private toastr = inject(ToastrService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry(0),
      catchError((error: unknown) => this.errorHandler(request, error as HttpErrorResponse, next)),
    );
  }

  private errorHandler(
    request: HttpRequest<unknown>,
    error: HttpErrorResponse,
    _next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const _authenticationService = this.injector.get(AuthenticationService);

    if (
      request.url.includes(environment.serverUrl) ||
      request.url.replace(/\/api\/v\d+/, '').includes(environment.serverUrl)
    ) {
      if (error.status === 0) {
        this.inaccessible();
      } else {
        if (error.status === 1001) {
          this.validationError(error);
        } else {
          this.internalServerError(error);
        }
      }
    } else {
      this.toastr.error(
        'An error that should not happened has happened. Sorry for that. Please contact the administrator',
      );
    }
    // TODO: LOG THE ERRORS
    if (!environment.production) {
      log.error('Request error', error);
    }
    throw error;
  }

  private inaccessible() {
    let message = 'The api server is not accessible';
    if (!environment.production) {
      message = message + '. (The webapi server is down)';
    }
    this.toastr.error(message);
  }

  private internalServerError(error: HttpErrorResponse) {
    if (error.status === 500) {
      // todo: add logging
      this.toastr.error(
        'An error that should not happened has happened. Sorry for that. Please contact the administrator of your company',
      );
    }
  }

  private validationError(error: HttpErrorResponse) {
    if (error.error.code.internalCode === 1001) {
      this.toastr.error('A validation error occured. Please correct your input');
    }
  }
}
